export enum ACTIONS {
  INCREASE_UNREAD_COUNT = "INCREASE_UNREAD_COUNT",
  DECREASE_UNREAD_COUNT = "DECREASE_UNREAD_COUNT",
  RESET_UNREAD_COUNT = "RESET_UNREAD_COUNT",
  RESET_STORE_CHAT = "RESET_STORE_CHAT",
  RESET_STATUS_CHAT = "RESET_STATUS_CHAT",
  RESET_ERROR_CHAT = "RESET_ERROR_CHAT",
  RESET_REPLY_MESSAGE_ID = "RESET_REPLY_MESSAGE_ID",
  RESET_LAST_READ_MESSAGE_INDEX = "RESET_LAST_READ_MESSAGE_INDEX",
  // ----------------------------------------
  GET_CHAT_INFO = "GET_CHAT_INFO",
  GET_CHAT_SETTINGS = "GET_CHAT_SETTINGS",

  GET_MESSAGES = "GET_MESSAGES",
  GET_PREV_MESSAGES = "GET_PREV_MESSAGES",
  GET_NEXT_MESSAGES = "GET_NEXT_MESSAGES",
  GET_MESSAGES_BY_REPLY = "GET_MESSAGES_BY_REPLY",

  POST_CHAT_INFO = "POST_CHAT_INFO",
  POST_MESSAGE = "POST_MESSAGE",
  POST_MESSAGE_FILE = "POST_MESSAGE_FILE",
  GET_FILE = "GET_FILE",
  // ----------------------------------------
  POST_EVENT_MESSAGE_READING = "POST_EVENT_MESSAGE_READING",
  POST_EVENT_USER_TYPING = "POST_EVENT_USER_TYPING",
  // ----------------------------------------
  UPDATE_MESSAGE_STATUSES = "UPDATE_MESSAGE_STATUSES",
  UPDATE_MESSAGE_FILE = "UPDATE_MESSAGE_FILE",
  // ----------------------------------------
  RESET_OPPONENT_LAST_TYPING_TIME = "RESET_OPPONENT_LAST_TYPING_TIME",
  SET_OPPONENT_LAST_TYPING_TIME = "SET_OPPONENT_LAST_TYPING_TIME",
  SET_OPERATOR_NAME = "SET_OPERATOR_NAME",
  SET_NOTIFICATION_INTERVAL_ID = "SET_NOTIFICATION_INTERVAL_ID",
  // ----------------------------------------
  INPUT_MESSAGE_CHANGE = "INPUT_MESSAGE_CHANGE",
  ADD_MESSAGES = "ADD_MESSAGES",
  READ_MESSAGE = "READ_MESSAGE",
  SET_REPLY_MESSAGE_ID = "SET_REPLY_MESSAGE_ID",
}
